export default function useTimezone() {
    const convertToClientTime = (dateTime) => {
        const utcDate = new Date(dateTime);
        const timezoneOffsetMinutes = new Date().getTimezoneOffset();

        return new Date(utcDate.getTime() - (timezoneOffsetMinutes * 60 * 1000));
    };

    const getClientTimezone = () => {
        try {
            if (Intl && Intl.DateTimeFormat) {
                return Intl.DateTimeFormat().resolvedOptions().timeZone;
            } else {
                console.error("Intl.DateTimeFormat is not supported. Using a fallback timezone.");
                return "UTC";
            }
        } catch (error) {
            console.error("Error getting user timezone:", error);
            return "UTC";
        }
    }

    const getClientTimezoneForScheduling = () => {
        const TIMEZONE_MAP = {
            'America/New_York': 'America/New_York',
            'America/Detroit': 'America/New_York',
            'America/Kentucky/Louisville': 'America/New_York',
            'America/Kentucky/Monticello': 'America/New_York',
            'America/Indiana/Indianapolis': 'America/New_York',
            'America/Indiana/Vincennes': 'America/New_York',
            'America/Indiana/Winamac': 'America/New_York',
            'America/Indiana/Marengo': 'America/New_York',
            'America/Indiana/Petersburg': 'America/New_York',
            'America/Indiana/Vevay': 'America/New_York',
            
            'America/Chicago': 'America/Chicago',
            'America/Indiana/Knox': 'America/Chicago',
            'America/Indiana/Tell_City': 'America/Chicago',
            'America/Menominee': 'America/Chicago',
            'America/North_Dakota/Center': 'America/Chicago',
            'America/North_Dakota/New_Salem': 'America/Chicago',
            'America/North_Dakota/Beulah': 'America/Chicago',
            
            'America/Denver': 'America/Denver',
            'America/Boise': 'America/Denver',
            
            'America/Phoenix': 'America/Phoenix',
            
            'America/Los_Angeles': 'America/Los_Angeles',
            
            'America/Anchorage': 'America/Anchorage',
            'America/Juneau': 'America/Anchorage',
            'America/Sitka': 'America/Anchorage',
            'America/Metlakatla': 'America/Anchorage',
            'America/Yakutat': 'America/Anchorage',
            'America/Nome': 'America/Anchorage',
            
            'Pacific/Honolulu': 'Pacific/Honolulu',
            'America/Adak': 'Pacific/Honolulu'
        };

        const browserTimezone = getClientTimezone();

        return TIMEZONE_MAP[browserTimezone] || 'America/New_York';
    }

    return {
        convertToClientTime,
        getClientTimezone,
        getClientTimezoneForScheduling
    };
}
